module.exports = __webpack_public_path__ + "img/icon-person.fc1c51aa.svg";